import script from "./app-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./app-header.vue?vue&type=script&lang=ts&setup=true"

import "./app-header.vue?vue&type=style&index=0&id=1e8ace85&lang=less"
import "./app-header.vue?vue&type=style&index=1&id=1e8ace85&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/sz-cd-pro4kg65/portal-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e8ace85"]])

export default __exports__